module.exports = __webpack_public_path__ + "img/xiangmu.639c4691.svg";